<div class="flex h-full flex-col">
  <div class="flex items-center pb-4 md:px-5 md:pb-0 md:pt-4">
    <dojo-search-input
      class="w-full"
      [formCtrl]="searchCtrl"
      [placeholder]="'examdojo.topics_tree.search_topics' | transloco"
      [compact]="true"
      [size]="searchSize()"
      (searchChanged)="onSearch($event)"
    ></dojo-search-input>
  </div>
  <ag-grid-angular
    class="ag-theme-unthemed h-full w-full flex-1"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="onSelectionChanged($event)"
  />
</div>
